import { render } from "./home-page.vue?vue&type=template&id=6bc6c1e8"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__